import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_close.svg'


const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "flex items-center justify-between px-6 pt-6 pb-4 border-b" }
const _hoisted_3 = { class: "text-20px font-semibold text-black-lp-300" }
const _hoisted_4 = { class: "px-6 pt-4 pb-2" }
const _hoisted_5 = {
  class: "border rounded-lg overflow-hidden",
  style: {"max-height":"60vh","overflow":"auto"}
}
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "sticky top-0 z-10 bg-white" }
const _hoisted_8 = { class: "text-14px text-black-lp-300 border-b font-semibold" }
const _hoisted_9 = { class: "text-left px-4 py-3 w-12" }
const _hoisted_10 = { class: "text-left px-4 py-3" }
const _hoisted_11 = { class: "text-center px-4 py-3 w-44" }
const _hoisted_12 = { class: "px-4 py-3 text-14px text-black-lp-300" }
const _hoisted_13 = { class: "px-4 py-3" }
const _hoisted_14 = { class: "text-black-lp-300 text-14px" }
const _hoisted_15 = { class: "text-gray-lp-300" }
const _hoisted_16 = { class: "text-12px text-gray-lp-800" }
const _hoisted_17 = { class: "px-4 py-3 text-center" }
const _hoisted_18 = { class: "text-black-lp-300 text-14px" }
const _hoisted_19 = { class: "text-12px text-gray-lp-800" }
const _hoisted_20 = { class: "px-4 py-3" }
const _hoisted_21 = { class: "px-4 py-3" }
const _hoisted_22 = { class: "px-4 py-3 text-center" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  colspan: 3,
  class: "px-4 py-6"
}
const _hoisted_25 = { class: "sticky bottom-0 bg-white border-t px-6 py-4 flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV3 = _resolveComponent("ModalV3")!

  return (_openBlock(), _createBlock(_component_ModalV3, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = $event)),
    customWidth: '635px',
    isPaddingTopBottom: false
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('topCustomer.title')), 1),
          _createVNode("img", {
            src: _imports_0,
            alt: "close",
            class: "w-6 h-6 text-black-lp-300 hover:text-black-lp-100 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          })
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("table", _hoisted_6, [
              _createVNode("thead", _hoisted_7, [
                _createVNode("tr", _hoisted_8, [
                  _createVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('topCustomer.table.no')), 1),
                  _createVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('topCustomer.table.customer')), 1),
                  _createVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('topCustomer.table.currentPeriod')), 1)
                ])
              ]),
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.topCustomers, (item, idx) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: `cust-${idx}`,
                    class: "border-t"
                  }, [
                    _createVNode("td", _hoisted_12, _toDisplayString(idx + 1), 1),
                    _createVNode("td", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _createTextVNode(_toDisplayString(item.name) + " ", 1),
                        _createVNode("span", _hoisted_15, "(" + _toDisplayString(_ctx.maskPhone(item.phoneNumber)) + ")", 1),
                        _createVNode("img", {
                          src: require('@/app/ui/assets/svg/whatsapp.svg'),
                          class: "inline-block w-4 h-4 ml-2 cursor-pointer align-middle",
                          alt: "whatsapp",
                          onClick: ($event: any) => (_ctx.openWhatsApp(item.phoneNumber))
                        }, null, 8, ["src", "onClick"])
                      ]),
                      _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('topCustomer.lastSent')) + " " + _toDisplayString(_ctx.formatDate(item.lastBooking)), 1)
                    ]),
                    _createVNode("td", _hoisted_17, [
                      _createVNode("div", _hoisted_18, _toDisplayString(_ctx.formatCurrency(item.performance.currentPeriode.amount)), 1),
                      _createVNode("div", _hoisted_19, _toDisplayString(item.performance.currentPeriode.stt) + " STT (" + _toDisplayString(item.performance.currentPeriode.weightKg) + " kg) ", 1)
                    ])
                  ]))
                }), 128)),
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, _renderList(5, (i) => {
                      return _createVNode("tr", {
                        key: `sk-${i}`,
                        class: "border-t"
                      }, [
                        _createVNode("td", _hoisted_20, [
                          _createVNode(_component_skeleton, {
                            width: "2rem",
                            height: "1rem"
                          })
                        ]),
                        _createVNode("td", _hoisted_21, [
                          _createVNode(_component_skeleton, {
                            width: "12rem",
                            height: "1rem"
                          }),
                          _createVNode(_component_skeleton, {
                            width: "8rem",
                            height: "0.8rem",
                            class: "mt-2"
                          })
                        ]),
                        _createVNode("td", _hoisted_22, [
                          _createVNode(_component_skeleton, {
                            width: "6rem",
                            height: "1rem"
                          }),
                          _createVNode(_component_skeleton, {
                            width: "8rem",
                            height: "0.8rem",
                            class: "mt-2"
                          })
                        ])
                      ])
                    }), 64))
                  : _createCommentVNode("", true),
                (!_ctx.loading && !_ctx.topCustomers.length)
                  ? (_openBlock(), _createBlock("tr", _hoisted_23, [
                      _createVNode("td", _hoisted_24, [
                        _createVNode(_component_EmptyState, {
                          buttonAction: false,
                          customMessage: _ctx.$t('topCustomer.empty'),
                          class: "py-2",
                          customClassImage: "mt-2"
                        }, null, 8, ["customMessage"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_25, [
          _createVNode(_component_LpButton, {
            title: _ctx.$t('topCustomer.ok'),
            color: "red-lp-100",
            textColor: "white",
            customClass: "px-8 py-2",
            onClick: _ctx.close
          }, null, 8, ["title", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}